var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgO2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_885)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1194 66.7606C29.1194 86.2809 43.2796 102.521 63.92 102.521C84.4003 102.521 98.6406 86.3609 98.6406 66.7606C98.6406 46.0402 84.7203 31 63.92 31C43.0396 31 29.1194 46.0402 29.1194 66.7606ZM42.5596 66.7606C42.5596 53.8004 50.4797 41.1602 64 41.1602C77.3602 41.1602 85.2803 53.7204 85.2803 66.7606C85.2803 78.9208 78.7202 92.361 64 92.361C49.1197 92.361 42.5596 78.9208 42.5596 66.7606Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.441 115.881V111.081H105.121C110.081 106.201 116.481 100.361 116.481 93.961C116.481 88.0409 112.801 85.1609 107.041 85.1609C104.001 85.1609 100.801 85.9609 98.0806 87.3209L98.5606 92.361C100.561 91.081 102.961 89.961 105.521 89.961C108.001 89.961 110.481 91.241 110.481 94.041C110.481 99.5611 100.241 108.201 97.3606 110.921V115.961L117.441 115.881Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgO2);
export default __webpack_public_path__ + "static/media/o2.7c6f34ea04f9c926ef54d58c49f3df54.svg";
export { ForwardRef as ReactComponent };